<template>
  <div class="PacienteInformacion">
    <v-card
      shaped
      outlined
      :loading="cargando"
      :disabled="cargando"
      color="primary"
      dark
    >
      <v-app-bar
        flat
        color="transparent"
      >
        <v-spacer />
        <v-btn
          icon
          v-bind="attrs"
          to="/login"
        >
          <v-icon>exit_to_app</v-icon>
        </v-btn>
        <!-- <v-menu> <template v-slot:activator="{ on, attrs }"> <v-btn icon v-bind="attrs" v-on="on" > <v-icon>more_vert</v-icon> </v-btn> </template> <v-list light> <v-list-item to="/paciente"><v-list-item-title v-text="'Editar perfil'" /></v-list-item><v-divider /> <v-list-item to="/login"> <v-list-item-title v-text="'Cerrar sesión'" /> </v-list-item> </v-list> </v-menu> -->
      </v-app-bar>
      <v-card-title
        style="heigth:auto!important"
        @click="$rotuer.push('/paciente')"
      >
        <v-avatar size="56">
          <v-img
            v-if="$session.get('foto')"
            alt="usuario"
            :src="'http://localhost/dentalmaster/dentalmaster-admin-api/uploads/imagenes/'+$session.get('foto')"
          />
          <v-img
            v-else
            :src="require('@/assets/avatars/profiles/perfil-generico-0'+perfil+'.png')"
          />
        </v-avatar>
        <p
          class="ml-3"
          style="text-transform:capitalize"
        >
          {{$session.get('nombreCompleto')}}
        </p>
        <v-spacer />
        <v-btn
          icon
          to="/paciente"
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
export default {
  name: "PacienteInformacion",
  mixins: [forms],
  data() {
    return {
      perfil: null,
    };
  },
  methods: {
    _selectRandomProfile() {
      const numero = Math.floor(Math.random() * (4 - 1 + 1) + 1);
      this.perfil = numero;
    },
  },
  created() {
    this._selectRandomProfile();
  },
};
</script>